module.exports = {
  apiRoot: process.env.REACT_APP_API_ROOT,
  trialDays: 30,
  checklistId: process.env.REACT_APP_CHECKLIST_ID,
  checklistUrl: process.env.REACT_APP_CHECKLIST_URL,
  stripe: {
    publishableAPIKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY,
  },
};
